// Admin interface JavaScript for WebAsk Integration
document.addEventListener('DOMContentLoaded', function() {
    const surveysContainer = document.getElementById('webask-surveys-container');
    const apiKey = webask_admin.api_key;
    
    if (surveysContainer && apiKey) {
        loadSurveys();
    }
    
    function loadSurveys() {
        // Show loading state
        surveysContainer.innerHTML = '<p>Загрузка опросов...</p>';
        
        // Make AJAX request to get surveys
        fetch(webask_admin.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'webask_get_surveys',
                nonce: webask_admin.nonce
            })
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                displaySurveys(data.data);
            } else {
                surveysContainer.innerHTML = `<p style="color: red;">Ошибка: ${data.data}</p>`;
            }
        })
        .catch(error => {
            console.error('Error loading surveys:', error);
            surveysContainer.innerHTML = '<p style="color: red;">Ошибка при загрузке опросов</p>';
        });
    }
    
    function displaySurveys(surveys) {
        if (!surveys || surveys.length === 0) {
            surveysContainer.innerHTML = '<p>Опросы не найдены</p>';
            return;
        }
        
        let html = '';
        surveys.forEach(survey => {
            const shortcode = `[webask_survey id="${survey.id}"]`;
            const publishedStatus = survey.is_published ? 
                '<span style="color: green;">✓ Опубликован</span>' : 
                '<span style="color: orange;">○ Не опубликован</span>';
            
            html += `
                <div class="survey-item">
                    <h4>${escapeHtml(survey.name)}</h4>
                    <div class="survey-meta">
                        ID: ${survey.id} | Статус: ${publishedStatus}
                        ${survey.folder ? ` | Папка: ${escapeHtml(survey.folder.name)}` : ''}
                    </div>
                    <p><strong>Шорткод:</strong></p>
                    <div class="survey-shortcode" onclick="copyToClipboard('${shortcode}')" title="Нажмите для копирования">
                        ${shortcode}
                    </div>
                    ${survey.url_shared ? `
                        <p style="margin-top: 10px;">
                            <a href="${escapeHtml(survey.url_shared)}" target="_blank" rel="noopener">
                                Открыть опрос ↗
                            </a>
                        </p>
                    ` : ''}
                </div>
            `;
        });
        
        surveysContainer.innerHTML = html;
    }
    
    function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }
    
    // Global function for copying shortcode to clipboard
    window.copyToClipboard = function(text) {
        navigator.clipboard.writeText(text).then(() => {
            // Show temporary success message
            const message = document.createElement('div');
            message.style.cssText = 'position: fixed; top: 50px; right: 20px; background: #46b450; color: white; padding: 10px; border-radius: 4px; z-index: 999999;';
            message.textContent = 'Шорткод скопирован!';
            document.body.appendChild(message);
            
            setTimeout(() => {
                document.body.removeChild(message);
            }, 2000);
        }).catch(() => {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            
            alert('Шорткод скопирован в буфер обмена!');
        });
    };
    
    // API key visibility toggle
    const apiKeyInput = document.getElementById('webask_api_key');
    if (apiKeyInput) {
        const toggleButton = document.createElement('button');
        toggleButton.type = 'button';
        toggleButton.className = 'button button-secondary';
        toggleButton.textContent = 'Показать';
        toggleButton.style.marginLeft = '10px';
        
        toggleButton.addEventListener('click', function() {
            if (apiKeyInput.type === 'password') {
                apiKeyInput.type = 'text';
                toggleButton.textContent = 'Скрыть';
            } else {
                apiKeyInput.type = 'password';
                toggleButton.textContent = 'Показать';
            }
        });
        
        apiKeyInput.parentNode.appendChild(toggleButton);
    }
});